<template>
  <custom-callout
    border-color="primary-2"
    class="mb-4 custom-callout rounded"
    :has-toggle="false"
  >
    <div class="py-2">
      <div class="d-flex">
        <icon-view
          class="mt-5 mb-3 mt-md-0 mt-sm-5"
          :gradient="false"
          icon="fas fa-exchange-alt mb-1"
          icon-background="#ff7058"
          icon-color="white"
          icon-size="16px"
          :title="title"
        />
      </div>
      <validation-observer ref="statusCardObserver">
        <div class="row my-3">
          <div class="col-md-3 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.status"
                :custom-error-msg="'El estatus es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Estatus:"
                :options="statuses"
                placeholder="Seleccione"
                @input="onStatusChange"
              />
            </validation-provider>
          </div>
        </div>
        <div class="d-flex flex-column justify-content-between mt-3 mb-0 pr-3">
          <div class="col-md-12 px-0">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-text-area
                v-model="model.comment"
                :custom-error-msg="'El comentario es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Comentario:"
                maxlength="500"
              />
            </validation-provider>
          </div>

          <div class="pl-0 pt-4">
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger mr-3 pl-3 pr-4"
              @click="onClose"
            />
            <action-button
              i="fas fa-arrow-alt-circle-right"
              text="Continuar"
              variant="success pl-3 pr-3"
              @click="onContinue"
            />
          </div>
        </div>
      </validation-observer>
    </div>
  </custom-callout>
</template>
<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import IconView from 'icon-view';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'CardStatusTransition',
  components: {
    IconView,
    ActionButton,
    CustomTextArea,
    CustomDropDown,
    CustomCallout,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    statuses: {
      type: Array,
      default: () => [],
    },
    defaultComment: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      required: true,
    },
    role: {
      type: String,
      default: () => '',
    },
  },
  data: () => ({
    model: {
      status: null,
      comment: null,
    },
  }),
  mounted() {
    if (this.defaultComment) this.model.comment = this.defaultComment;
  },
  methods: {
    onStatusChange() {
      if (this.defaultComment) return;
      const { name } = this.model.status;
      this.model.comment = `Solicitud cambiada a ${name} por ${this.role}.`;
    },
    onClose() {
      this.$emit('on-close');
    },
    async onContinue() {
      const isValid = await this.$refs.statusCardObserver.validate();
      if (!isValid) return;
      this.$emit('on-continue', this.model);
    },
  },
};
</script>
